import {useAtom, useSetAtom} from 'jotai';
import styled from 'styled-components';
import {useGA4WithParams} from '@/hooks/tracking';
import {
  compareAreaItemsAtom,
  mapSideInfoAtom,
  openCompareAreaAtom,
} from '@/map/atom';
import {CompareArea} from '../CompareArea';
import {AnalysisMenu} from './AnalysisMenu';
import {CompareAreaButton} from './CompareAreaButton';
import {Search} from './Search';

interface IProps {
  map?: naver.maps.Map;
}

export const FloatingMenu = ({map}: IProps) => {
  const [openComparePanel, setActiveComparePanel] =
    useAtom(openCompareAreaAtom);
  const setSelectedCompareArea = useSetAtom(compareAreaItemsAtom);
  const [sideInfo, setSideInfo] = useAtom(mapSideInfoAtom);

  const tracking = useGA4WithParams();

  const onCompareMenuClick = () => {
    setActiveComparePanel((prev) => {
      if (!prev) {
        tracking('analysis_compare_open');
      }
      return !prev;
    });

    if (sideInfo?.open) {
      setSideInfo((prev) => ({
        ...prev,
        open: false,
      }));
    }
    setSelectedCompareArea([]);
  };

  return (
    <Root>
      <Box>
        <Search map={map} />
        <MenuBar>
          <AnalysisMenu />
          <CompareAreaButton
            open={openComparePanel}
            onMenuIconClick={onCompareMenuClick}
          />
        </MenuBar>
      </Box>
      {!!map && openComparePanel && (
        <CompareArea
          map={map}
          onClose={() => {
            setActiveComparePanel(false);
            setSelectedCompareArea([]);
          }}
        />
      )}
    </Root>
  );
};

const Root = styled.div`
  display: flex;
  flex-direction: column;
  width: 320px;
  gap: 8px;
  position: absolute;
  top: 0;
  bottom: 0;
  pointer-events: none;
`;

const Box = styled.div`
  width: 100%;
  padding: 6px;
  border-radius: 8px;
  box-shadow: 0px 4px 10px 0px #00000026;
  background: #fffffff2;
  display: flex;
  flex-direction: column;
  gap: 4px;
  pointer-events: auto;
`;

const MenuBar = styled.div`
  display: flex;
  gap: 2px;
`;
